<div class="bp-info-box">
	<span class="bp-info-box-icon bpi__icon-info"></span>
	<ng-content></ng-content>
</div>
